module.exports = __webpack_public_path__ + "media/images/flags/er-04bcc2d33f7632c0195f6e3f4b616d85.svg";